// Single decision for the "What's your name?" onboarding gate. Social sign-ins
// (notably Apple with a hidden email) can leave the profile nameless, which
// shows as "Unnamed User" and breaks DocuSign signer names.

interface NamedProfile {
  first_name?: string | null;
  last_name?: string | null;
}

export function needsName(profile: NamedProfile | null | undefined): boolean {
  if (!profile) return false; // profile not loaded yet — never trap on missing data
  return !profile.first_name?.trim() || !profile.last_name?.trim();
}

/** Best-effort split of the name an identity provider sent at sign-in. */
export function nameFromMetadata(meta: Record<string, unknown> | null | undefined): { first: string; last: string } {
  const str = (v: unknown) => (typeof v === "string" ? v.trim() : "");
  const given = str(meta?.given_name) || str(meta?.first_name);
  const family = str(meta?.family_name) || str(meta?.last_name);
  if (given || family) return { first: given, last: family };
  const full = (str(meta?.full_name) || str(meta?.name)).replace(/\s+/g, " ");
  const i = full.indexOf(" ");
  return i === -1 ? { first: full, last: "" } : { first: full.slice(0, i), last: full.slice(i + 1) };
}
